import compose from 'ramda/src/compose'
import prop from 'ramda/src/prop'
import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

export default compose(prop('isPinnedDare'), getRecordSelector)
